import { render, staticRenderFns } from "./OrganizationSales.vue?vue&type=template&id=1583d99c"
import script from "./OrganizationSales.vue?vue&type=script&lang=js"
export * from "./OrganizationSales.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSales.vue?vue&type=style&index=0&id=1583d99c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1583d99c')) {
      api.createRecord('1583d99c', component.options)
    } else {
      api.reload('1583d99c', component.options)
    }
    module.hot.accept("./OrganizationSales.vue?vue&type=template&id=1583d99c", function () {
      api.rerender('1583d99c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/metrics/OrganizationSales.vue"
export default component.exports